<template>
    <div>
        <DCard
            padding
        >
            <DFormRow
                :label="__('products.dnsTemplate.index.table.headers.name')"
            >
                <DInput
                    id="name"
                    :value="dnsTemplate.name"
                    :disabled="true"
                />
            </DFormRow>
            <DFormRow
                :label="__('products.dnsTemplate.index.table.headers.isDefault')"
            >
                <DInput
                    id="is_default"
                    :value="dnsTemplate.is_default ? __('products.dnsTemplate.index.table.values.default.yes') : __('products.dnsTemplate.index.table.values.default.no')"
                    :disabled="true"
                />
            </DFormRow>
            <DFormRow
                :label="__('products.dnsTemplate.form.style')"
                :is-required="true"
            >
                <DSelect
                    v-model="dnsTemplateStyle"
                    :options="nameserverStyle"
                    :value="dnsTemplate.style"
                    :disabled="true"
                />
            </DFormRow>
            <DFormRow
                v-if="dnsTemplate.style === 'default'"
                :label="__('products.dnsTemplate.form.dns_provider')"
                :is-required="true"
            >
                <DSelect
                    v-model="dnsTemplateDnsProvider"
                    :options="dnsProviders"
                    :value="dnsTemplate.dns_provider"
                    :disabled="true"
                />
            </DFormRow>
            <DFormRow
                :label="__('products.dnsTemplate.form.template')"
            >
                <DFormTextarea
                    id="template"
                    :value="templateJson"
                    rows="10"
                    :disabled="true"
                />
            </DFormRow>
        </DCard>

        <DFabs>
            <DFab
                v-if="userPermissions.includes('dns_templates.edit')"
                id="btn-edit"
                icon="pencil"
                :label="__('messages.actions.edit')"
                @click="$inertia.get($route('products.dns-templates.edit', dnsTemplate.id))"
            />
        </DFabs>
    </div>
</template>

<script>
export default {
    name: 'DNSTemplateShow',
    props: {
        dnsTemplate: {
            type: Object,
            default () {
                return {}
            }
        },
        nameserverStyle: {
            type: Array,
            default () {
                return []
            }
        },
        dnsProviders: {
            type: Array,
            default () {
                return []
            }
        }
    },
    emits: ['update:dnsTemplate'],
    data () {
        return {
            dnsTemplateStyle: this.dnsTemplate.style,
            dnsTemplateDnsProvider: this.dnsTemplate.dns_provider
        }
    },
    computed: {
        templateJson () {
            return JSON.stringify(this.dnsTemplate.template, null, 6)
        },
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    watch: {
        // Watch for changes to dnsTemplateStyle and emit back the updated value
        dnsTemplateStyle (newValue) {
            this.$emit('update:dnsTemplate', {
                ...this.dnsTemplate,
                style: newValue
            })
        },
        // Watch for changes to dnsTemplateDnsProvider and emit back the updated value
        dnsTemplateDnsProvider (newValue) {
            this.$emit('update:dnsTemplate', {
                ...this.dnsTemplate,
                dns_provider: newValue
            })
        }
    }
}
</script>
